import PropTypes from 'prop-types';

export const messageStruct = PropTypes.shape({
  bannerId: PropTypes.string.isRequired,
  descriptionId: PropTypes.string.isRequired,
  descriptionComponent: PropTypes.element,
  severity: PropTypes.oneOf(['warning', 'error']),
  additionalAttributes: PropTypes.arrayOf(PropTypes.string),
});

export const messageToDisplayStruct = PropTypes.shape({
  account: PropTypes.arrayOf(messageStruct),
  project: PropTypes.arrayOf(messageStruct),
});
